import { Component, OnInit } from '@angular/core';
import { BreadcrumbItem, DpTab } from '@docpath/webcomponents';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { RoutingPath } from 'src/app/constants/routing-path';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html'
})
export class ConfigurationComponent implements OnInit {

  icon = faCog;
  tabs: DpTab[] = [
    new DpTab('configuration.tab.general', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_GENERAL}`),
    new DpTab('configuration.tab.services', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_SERVICES}`),
    new DpTab('configuration.tab.alert-rules', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_ALERT_RULES}`),
    new DpTab('configuration.tab.failed-jobs', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_FAILED_JOBS}`),
    new DpTab('configuration.tab.alias', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_ALIAS}`),
    new DpTab('configuration.tab.engines', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_ENGINES}`),
    new DpTab('configuration.tab.self-maintenance', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_SELF_MAINTENANCE}`)
  ];

  breadCrumb: BreadcrumbItem[] = [];

  constructor(
      private readonly translateService: TranslateService
    ) {}
    
      ngOnInit(): void {
    
        this.translateService.onLangChange.subscribe(() => {
          this.reloadBreadCrumb();
        });
        
        this.reloadBreadCrumb();
    
      }
    
      private reloadBreadCrumb() {
        this.breadCrumb = [
          { label: environment.APP_NAME, width: '240px' },
          { label: this.translateService.instant('configuration.title') }
        ];
      }

}
